import { Avatar } from "@circle-react-uikit/SkeletonLoader/components/Avatar";
import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

export const CommunityMemberSkeleton = () => (
  <li
    className="border-primary bg-primary group rounded-xl border-[1px] p-6 first:mt-4 first:md:mt-0"
    data-testid="community-member-skeleton"
  >
    <div className="flex w-full gap-x-4">
      <div style={{ aspectRatio: "1 / 1" }} className="h-16">
        <Avatar md />
      </div>
      <section className="flex min-w-0 flex-1 flex-col gap-y-3">
        <div className="flex flex-col gap-y-2">
          <Row lg long />
          <Row md half />
          <Row sm className="!w-3/4" />
        </div>
        <div className="flex gap-2">
          <Row xs className="!h-6 !w-16 !rounded-full" />
          <Row xs className="!h-6 !w-20 !rounded-full" />
        </div>
      </section>
    </div>
  </li>
);
